import { __rest } from "tslib";
import React, { useMemo } from 'react';
import { theme } from '../../theme';
import { Stack } from '../../components/Stack';
import { RootStack, Label, Hint, Error, BlockTooltip } from './styled';
import { HelpIcon } from '../../tempIcons/HelpIcon';
import { generateId } from '../../utils/generateId';
export const withLabels = (Component) => (_a) => {
    var { label, hint, error, tooltip } = _a, otherProps = __rest(_a, ["label", "hint", "error", "tooltip"]);
    const componentId = useMemo(() => generateId(Component.name), []);
    if (!label) {
        return React.createElement(Component, Object.assign({ hasError: !!error }, otherProps));
    }
    return (React.createElement(RootStack, { spacing: "sm", alignX: "stretch" },
        React.createElement("div", null,
            React.createElement(Stack, { direction: "horizontal", alignY: "center", spacing: "sm" },
                React.createElement(Label, { htmlFor: componentId }, label),
                tooltip && (React.createElement(BlockTooltip, { text: tooltip },
                    React.createElement(HelpIcon, { width: theme.sizes.base, height: theme.sizes.base, color: theme.colors.neutral.ink.light })))),
            hint && React.createElement(Hint, null, hint)),
        React.createElement(Component, Object.assign({ id: componentId, hasError: !!error }, otherProps)),
        error && React.createElement(Error, null, error)));
};
//# sourceMappingURL=withLabels.js.map